export default function CsharpEnums() {
  return (
    <h2>Csharp Enums</h2>
  );
}
